// Contract 29 §15.2 — the onboarding connect step's HOST seam.
//
// Step 3 lists module 12's platforms, and a connected Hardal / Adjust / AppsFlyer account opens
// module 30's follow-up modals (v3 `OnboardingConnectPlatforms.vue:583-605`). 29 may import 12 but
// never 30, so the composition root — the one file that knows both — installs a host component
// that composes the two, exactly as `ConnectionsSettingsHost` does for the Settings page.

import type { Component } from 'vue'

export type OnboardingPlatformsHostLoader = () => Promise<Component | { default: Component }>

let loader: OnboardingPlatformsHostLoader | null = null

/** Install the host. Re-installing the same loader is a safe no-op. */
export function registerOnboardingPlatformsHost(next: OnboardingPlatformsHostLoader): void {
  if (loader === next) return
  if (loader) throw new Error('[global-surface] an onboarding platforms host is already registered')
  loader = next
}

/** The installed host loader, or `null` before composition ran (the step then renders 12's list
 *  alone — follow-ups degrade, connecting does not). */
export function onboardingPlatformsHost(): OnboardingPlatformsHostLoader | null {
  return loader
}

/** Test isolation only. */
export function resetOnboardingPlatformsHostForTest(): void {
  loader = null
}
